import { useTranslation } from 'react-i18next';
import Tooltip from './tooltip';
import useProblemSolvers from './hook';
import Widget from '../../../../../../../../Analysis/widget';
import { renderTooltipJsx } from '../../../../../../../../../helpers/Tooltip';
import Chart from '../../../../../../../pme/screens/dashboard/widgets/sdgs/chart';

export const solversColors = [
  '#384E3B', '#82B88A', '#9BC4A1', '#B4D3B9', '#D9E9DC'
];

export default function ProblemSolvers({ data = [], loading }) {
  const { t } = useTranslation();
  const { filtersConfig } = useProblemSolvers();

  const isEmpty = !data.length;

  const _renderTooltip = ({ mouseX, mouseY, item }) => {
    return (
      <Tooltip
        mouseY={mouseY}
        mouseX={mouseX}
        children={renderTooltipJsx({
          title: !isEmpty ? t(item.name) : t('Implementers'),
          link: !isEmpty && item.name !== 'Undetermined' && item.name ? `/app/tazama/view/stakeholder/${item?.implementerData?.datastakeId}/linking` : undefined,
          items: [
            {
              color: !isEmpty ? item.color : '#E5E7EB',
              label: t('Number of actions'),
              value: !isEmpty ? Number(item.actions).toLocaleString('en-us') : 0,
            },
          ]
        })}
      />
    )
  }

  return (
    <Widget
      loading={loading}
      title={t('Problem Solvers')}
      filtersConfig={filtersConfig}
      className="with-border-header">
      <div className='flex flex-1 flex-column justify-content-center pl-4 pr-4'>
        <div className='flex justify-content-center'>
          <Chart
            changeOpacityOnHover={false}
            data={data}
            t={t}
            withBody={false}
            isEmpty={isEmpty}
            renderTooltip={_renderTooltip}
            className="no-max-width small-chart"
          />
        </div>
      </div>
    </Widget>
  );
}
